/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\Carrier\CarrierSerice.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday July 26th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday, 13th September 2023 08:51:57
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { UpdatableOffer, UpdatableSingleOffer } from "Type/offer.type";
import generalQueryParams from "Type/params.type";
import { FromRefTime, buildAxiosHeader, buildURL } from "Utils/Request.utils";
import Axios from "axios";

export default class OfferService {
    static async updateOffer(myIntels: UpdatableOffer, offerId: string) {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFER}/${offerId}`;
        const myOffer = await Axios.put(url, myIntels, buildAxiosHeader());
        return myOffer;
    };

    static async updateSingleOffer(myIntels: UpdatableSingleOffer, offerId: string) {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFER}/${offerId}`;
        const myOffer = await Axios.put(url, myIntels, buildAxiosHeader());
        return myOffer;
    };

    static async getOfferInfo() {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFERCARINFO}`;
        const offersInfo = await Axios.get(url, buildAxiosHeader());
        return offersInfo.data;
    }

    static async getAllOffers(params: generalQueryParams) {
        if (params.from)
            params.from = FromRefTime(params.from);
        const myUrl = buildURL(params,`${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFER}`);
        const myOffers = await Axios.get(myUrl, buildAxiosHeader());
        return myOffers.data;
    };

    static isLastInSell(inSellID: string) {
        const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.INSELL}/${inSellID}`;
        return Axios.get(url, buildAxiosHeader());
    };

    // static async getUserOffer(userID: string) {
    //     const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFER}/${userID}`;
    //     const offers = await Axios.get(url, buildAxiosHeader());
    //     return offers.data;
    // };

    // static async getCompanyOffer(companyID: string) {
    //     const url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.OFFER}/company/${companyID}`;
    //     const offers = await Axios.get(url, buildAxiosHeader());
    //     return offers.data;
    // };
}
